// Chia gói khi nhập tệp LỚN trên trang Super "Bản đồ giao diện". Lỗi thật (khảo sát thật của bot 23/09, 11,5 MB): trang cho tệp tới 20 MB và nginx cho 20 MB
// nhưng máy chủ chỉ nhận body 8 MB (server/src/http.ts MAX_BODY) → "Nội dung quá lớn". Tệp khảo sát xuất có thụt dòng; bỏ thụt dòng và tách theo MẠNG
// (host) thì mỗi gói chỉ 0,4–2,2 MB. Hàm thuần (không DOM) để test; kiểm kích thước TẤT CẢ gói trước khi gửi gói nào — không bao giờ nhập dở.
export const GIOI_HAN_GOI = 7.5 * 1024 * 1024; // byte cho cả body { tenTep, noiDung }; máy chủ nhận tối đa 8 MB

export interface GoiNhap { nhan: string; noiDung: string | object }

const mahoa = new TextEncoder();
const byteCuaBody = (tenTep: string, noiDung: unknown): number => mahoa.encode(JSON.stringify({ tenTep, noiDung })).length;
const dungLuong = (b: number): string => (b >= 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);

export function chiaGoiNhap(txt: string, tenTep: string, opts: { gioiHan?: number } = {}): GoiNhap[] {
  const gh = opts.gioiHan ?? GIOI_HAN_GOI;
  // Tệp vừa → một yêu cầu nguyên văn như trước (máy chủ tự kiểm JSON/hình dạng và báo lỗi quen thuộc).
  if (byteCuaBody(tenTep, txt) <= gh) return [{ nhan: tenTep, noiDung: txt }];
  let o: unknown;
  try { o = JSON.parse(txt); } catch (e) { throw new Error(`Tệp “${tenTep}” không phải JSON hợp lệ (có thể bị cắt dở): ${(e as Error).message}`); }
  const tuyet = o as { xuatLuc?: unknown; host?: unknown } | null;
  if (tuyet && typeof tuyet === "object" && !Array.isArray(tuyet) && Array.isArray(tuyet.host)) {
    const goi: GoiNhap[] = tuyet.host.map((h: unknown, i: number) => ({
      nhan: typeof (h as { host?: unknown })?.host === "string" ? (h as { host: string }).host : `mục ${i + 1}`,
      noiDung: { xuatLuc: tuyet.xuatLuc, host: [h] },
    }));
    for (const g of goi) {
      const b = byteCuaBody(tenTep, g.noiDung);
      if (b > gh) throw new Error(`Mạng “${g.nhan}” trong tệp “${tenTep}” quá lớn (${dungLuong(b)} sau khi nén) — máy chủ chỉ nhận tối đa ${dungLuong(gh)} mỗi lần; hãy khảo sát ít trang hơn cho mạng này rồi nhập lại`);
    }
    return goi;
  }
  // Không phải khảo sát (bản đồ xuất, khối tuỳ chỉnh): bỏ thụt dòng, gửi một gói.
  const b = byteCuaBody(tenTep, o);
  if (b > gh) throw new Error(`Tệp “${tenTep}” quá lớn (${dungLuong(b)} sau khi nén) — máy chủ chỉ nhận tối đa ${dungLuong(gh)} mỗi lần; hãy chia nhỏ tệp rồi nhập lại`);
  return [{ nhan: tenTep, noiDung: o as object }];
}
